























































import Vue from "vue";
import { AuthenticationApi } from "@/api";
import stateMixin from "@/mixins/state";

export default Vue.extend({
  data() {
    return {
      emailAddress: "",
      rules: {
        emailAddress: [(v: string) => !!v || "E-mailadres is verplicht"]
      },
      valid: true
    };
  },
  name: "ResetPassword",
  mounted() {},
  mixins: [stateMixin],
  methods: {
    handleSubmit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        try {
          const api = new AuthenticationApi();
          const { data } = await api.authenticationRequestPasswordResetToken({
            emailAddress: this.emailAddress
          });
          (this.$refs.form as HTMLFormElement).reset();
          this.setState(this.states.COMPLETED);
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    }
  }
});
